import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader_main">
      <CircularProgress disableShrink />
    </div>
  );
};

export default Loader;
